module.exports = __webpack_public_path__ + "img/antes_despues_231.8c88e4a7.png";